module.exports = __webpack_public_path__ + "static/cs4-fb50442f696eb25cf630a5de6d46e877.jpg";